import React, { useState } from 'react';

interface SolutionMediaProps {
  media?: {
    type: 'image' | 'video';
    url: string;
    fileName: string;
  };
  className?: string;
}

const SolutionMedia: React.FC<SolutionMediaProps> = ({ media, className = '' }) => {
  const [error, setError] = useState(false);

  if (!media || !media.url || error) {
    return null;
  }

  const getFullUrl = (url: string) => {
    // If the URL is already absolute, return as is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // If URL starts with /uploads, it's from our server's static directory
    if (url.startsWith('/uploads')) {
      console.log('Using existing uploads path:', url);
      return url;
    }

    // If URL starts with /images, it is served directly from the client's public folder
    if (url.startsWith('/images/')) {
      return url;
    }
    
    // Otherwise, prepend with uploads path
    const fullUrl = `/uploads/${url}`;
    console.log('Created full URL:', fullUrl);
    return fullUrl;
  };

  const mediaUrl = getFullUrl(media.url);
  console.log('Solution media URL:', mediaUrl);

  const handleError = () => {
    console.error(`Media failed to load: ${mediaUrl}`);
    setError(true);
  };

  return (
    <div className={`rounded-lg overflow-hidden shadow-lg ${className}`}>
      {media.type === 'image' ? (
        <img 
          src={mediaUrl}
          alt="Solution illustration"
          className="w-full h-auto"
          onError={handleError}
        />
      ) : (
        <video 
          src={mediaUrl}
          controls
          className="w-full h-auto"
          onError={handleError}
        />
      )}
    </div>
  );
};

export default SolutionMedia; 